import React, { useEffect } from "react";
import CartDrawer from "../AdminComponents/CartDrawer";
import DrawerTitle from "./DrawerTitle";
import LoginCustomer from "../AllTabs/LoginCustomer";
import AccountTab from "../AllTabs/AccountTab";
import { AllTabType, IAddressData } from "src/types/GlobalInterfaces";
import MyOrdersScreen from "../AllTabs/MyOrdersScreen";
import MyActivityScreen from "../AllTabs/MyActivityScreen";
import MyResultsScreen from "../AllTabs/MyResultsScreen";
import MyAppointmentScreen from "../AllTabs/MyAppointmentScreen";
import MyDoctorsScreen from "../AllTabs/MyDoctorsScreen";
import ManageDoctorScreen from "../AllTabs/ManageDoctorScreen";
import NotificationScreen from "../AllTabs/NotificationScreen";
import ManageNotificationsScreen from "../AllTabs/ManageNotificationsScreen";
import ManageAddressScreen from "../AllTabs/ManageAddressScreen";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import EditProfileScreen from "../AllTabs/EditProfileScreen";
import MyHealthProfileScreen from "../AllTabs/MyHealthProfileScreen";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  tab?: AllTabType;
  className?: string;
  onSelectAddress?: (address: IAddressData | null) => void;
}

const AccountDrawer: React.FC<IProps> = ({
  isOpen,
  onClose,
  tab,
  className,
  onSelectAddress,
}) => {
  const [activeTab, setActiveTab] = React.useState<AllTabType>("Account");
  const [currentDoctor, setCurrentDoctor] = React.useState<any>(null);
  const { isLogged } = useSelector((state: RootState) => state.appReducer);

  useEffect(() => {
    if (tab && isOpen) {
      setActiveTab(tab);
    }
  }, [tab, isOpen]);

  const handleBack = () => {
    setActiveTab("Account");
    setCurrentDoctor(null);
  };

  const getActiveTab = (activeTab: AllTabType) => {
    switch (activeTab) {
      case "Account":
        return <AccountTab setActiveTab={setActiveTab} onClose={onClose} />;
      case "MyOrders":
        return (
          <MyOrdersScreen onBack={handleBack} setActiveTab={setActiveTab} onClose={onClose} />
        );
      case "EditProfile":
        return (
          <EditProfileScreen onBack={handleBack} setActiveTab={setActiveTab} onClose={onClose} />
        );

      case "MyActivity":
        return (
          <MyActivityScreen onBack={handleBack} setActiveTab={setActiveTab} onClose={onClose} />
        );
      case "MyResults":
        return (
          <MyResultsScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            onClose={onClose}
          />
        );
      case "MyDoctor":
        return (
          <MyDoctorsScreen
            onBack={() => {
              setCurrentDoctor(null);
              handleBack();
            }}
            setActiveTab={setActiveTab}
            setCurrentDoctor={setCurrentDoctor}
            onClose={onClose}
          />
        );
      case "ManageDoctor":
        return (
          <ManageDoctorScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            currentDoctor={currentDoctor}
            setCurrentDoctor={setCurrentDoctor}
            onClose={onClose}
          />
        );
      case "Notifications":
        return (
          <NotificationScreen onBack={handleBack} setActiveTab={setActiveTab} onClose={onClose} />
        );
      case "MyAppointment":
        return (
          <MyAppointmentScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            onClose={onClose}
          />
        );
      case "ManageNotifications":
        return (
          <ManageNotificationsScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            onClose={onClose}
          />
        );
      case "ManageAddress":
        return (
          <ManageAddressScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            onSelectAddress={onSelectAddress}
            onClose={onClose}
          />
        );
      case "MyHealthProfile":
        return (
          <MyHealthProfileScreen
            onBack={handleBack}
            setActiveTab={setActiveTab}
            onClose={onClose}
          />
        );
      default:
        return <AccountTab setActiveTab={setActiveTab} onClose={onClose} />;
    }
  };

  return (
    <CartDrawer isOpen={isOpen} onClose={onClose} className={ `${className} !bg-[#F6FAFF]`}>
      {isLogged ? getActiveTab(activeTab) : <LoginCustomer onBack={onClose} />}
    </CartDrawer>
  );
};

export default AccountDrawer;
